



















































































import { Component, Vue } from 'vue-property-decorator'
import TableForm from '@/components/common/TableForm.vue'
import SearchForm from '@/components/common/SearchForm.vue'
import CompareDialog from './CompareDialog.vue'
import StatusEffective from '@/components/common/StatusEffective.vue'

import $Api from '@api'
import { finalize } from 'rxjs/operators'
import { Bank, Channel } from '@/api/model/channel'
import { statusMap } from '@/utils/status-map'

@Component({
    components: {
        SearchForm,
        TableForm,
        CompareDialog,
        StatusEffective
    }
})
export default class extends Vue {
    searchForm = {
        current: 1,
        size: 10,
        channelId: null,
        bankId: null,
        status: null
    }
    statusMap = statusMap
    statusOptions = statusMap.createArray()
    channelOptions: Channel[] = []
    bankOptions: Bank[] = []

    tableLoading = false
    tableData = []
    total = 0

    formProp = {}
    show = false
    disabled = false

    onSearchSubmit() {
        this.searchForm.current = 1
        this.getData()
    }

    getChannels() {
        $Api.channelService
            .queryChannelDropdown()
            .subscribe(data => {
                this.channelOptions = data
            })
    }

    getBanks() {
        $Api.channelService
            .queryAbroadBankDropdown()
            .subscribe(data => {
                this.bankOptions = data
            })
    }

    getData(pageQuery = {}) {
        this.tableLoading = true
        $Api.channelService
            .routeControlList(Object.assign(this.searchForm, pageQuery))
            .pipe(
                finalize(() => {
                    this.tableLoading = false
                })
            )
            .subscribe(data => {
                this.tableData = data.list
                this.total = data.total
            })
    }

    // 新建
    create() {
        this.formProp = {}
        this.show = true
        this.disabled = false
    }

    // 编辑
    modify(row: any) {
        this.formProp = { ...row }
        this.show = true
        this.disabled = false
    }

    // 查看
    view(row: any) {
        this.formProp = { ...row }
        this.show = true
        this.disabled = true
    }

    created() {
        this.getData()
        this.getChannels()
        this.getBanks()
    }
}
